import { api } from './api';

const ordersService = {
  // Créer une commande
  createOrder: async (orderData) => {
    const response = await api.post('/public/orders', orderData);
    return response.data;
  },

  // Récupérer les commandes de l'utilisateur connecté
  getMyOrders: async () => {
    const response = await api.get('/public/orders/my-orders');
    return response.data;
  },

  // Annuler une commande
  cancelOrder: async (orderId) => {
    const response = await api.patch(`/public/orders/${orderId}/cancel`, {});
    return response.data;
  }
};

export default ordersService;
